import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-variable-deduction-form',
  templateUrl: './variable-deduction-form.component.html',
  styleUrls: ['./variable-deduction-form.component.css']
})
export class VariableDeductionFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/emp-salary-details/variable-deductions/variable-deduction-form/variable-deduction-form.component.ts